export default __webpack_public_path__ + "static/media/1.f4b7f812.jpg";